import React from 'react'

const VerificarPago = () => {
    return (
        <div className="verificar-pago">
            <div className="card">
                <div
                    style={{
                        borderRadius: 200,
                        height: 200,
                        width: 200,
                        background: "#F8FAF5",
                        margin: "0 auto"
                    }}
                >
                    <i className="checkmark">✓</i>
                </div>
                <h1>Éxito</h1>
                <p>
                    Recibimos su solicitud de compra;
                    <br /> ¡Estaremos en contacto en breve!
                </p>
            </div>
        </div>

    )
}

export default VerificarPago